import React from "react";
import cx from "clsx";
import {loadCurrentFontSize} from "@/app/(index)/util";
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import {Image} from "@mantine/core";


const ChronicleEnContent = () => {
    const { fontSize } = useGlobalStateStore();
    return (
        <div className={cx("leading-10 text-justify", loadCurrentFontSize(16, 20, 24, fontSize))}>
            <img className="float-right ms-10 mb-5" src="/images/1050614_1.jpg"/>
            <p>
                The Science & Technology Policy Research and Information Center (STPI), established in 1974, aims to support
                the government's technology policy-making and addressing social needs for globalization and the coming era
                of knowledge economy. Functioning as the main government think-tank for science and technology policy and
                the major platform for incorporating Taiwan's research communities, STPI has utilized over 40 years
                experience in collecting, collating and disseminating science & technology information for the purposes of
                innovation, competitiveness, sustainable development and social well-being and has integrated and provided
                with several nationwide technology related information services in improving the efficiency of scientific
                research. In order to fulfill its missions as the main think-tank for the government's technology
                policy-making, the future vision of STPI is to continue advancing the level in support of science &
                technology policy and information services and improving the nation's science & technology competitiveness
                by creating a sound science & technology policy research infrastructure and setting up academic and policy
                databases, methodology, tools and core competencies with authoritative and international standard. With
                sound academic foundation and empirical research capabilities, STPI is advancing toward its major goal as a
                world-class policy research institution.
            </p>
        </div>
    );
}


export default ChronicleEnContent;